<template>
  <div>
    <!-- Second Part Header of Quadrants -->
    <div class="box">
      <div class="columns has-text-centered">
        <div class="column is-one-third">
          <span class="heading has-text-weight-bold"
            >Prioridad de intervención</span
          >
          <div class="column">
            <table class="is-flex is-fullwidth" id="table-1">
              <tr
                class="bg-alta"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es mayor o igual a 30%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Alta
              </tr>
              <tr
                class="bg-media"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es menor a 30%, pero Riesgo alto, muy alto y medio es mayor o igual a 40%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Media
              </tr>
              <tr
                class="bg-destacado"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'>Si sin riesgo o riesgo bajo es mayor o igual a 60%</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Destacado
              </tr>
            </table>
          </div>
        </div>
        <div style="width: 15% !important; margin: auto !important">
          <div class="ranking ranking-only-icon">
            <img
              src="@/assets/icons/ranking-linear.svg"
              alt="rankingIconCL7"
              width="60"
            />
            <div class="info">
              <span class="subtitle-ranking">
                Entre
                <strong>0</strong>
                Empresa
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <span class="heading has-text-weight-bold">Niveles de riesgo</span>
          <div class="column">
            <table class="is-flex is-fullwidth" id="table-2">
              <tr
                class="bg-muyAlto"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Muy alto</strong><br><br>Nivel de riesgo con amplia posibilidad de asociarse a respuestas muy altas de estrés. Por consiguiente, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención inmediata en el marco de un sistema de vigilancia epidemiológica.</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Muy alto
              </tr>
              <tr
                class="bg-alto"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Alto</strong><br><br>Nivel de riesgo que tiene una importante posibilidad de asociación con respuestas de estrés alto y por tanto, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención en el marco de un sistema de vigilancia epidemiológica.</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Alto
              </tr>
              <tr
                class="bg-media"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Medio</strong><br><br>Nivel de riesgo en el que se esperaría una respuesta de estrés moderada. Las dimensiones y dominios que se encuentren bajo esta categoría ameritan observación y acciones sistemáticas de intervención para prevenir efectos perjudiciales en la salud.</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Medio
              </tr>
              <tr
                class="bg-bajo"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Bajo</strong><br><br>No se espera que los factores psicosociales que obtengan puntuaciones en este nivel estén relacionados con síntomas o respuestas de estrés significativas. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de intervención, a fin de mantenerlos en los niveles de riesgo más bajos posibles.<br><strong>Este rango no aplica para las condiciones individuales.</strong></span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Bajo
              </tr>
              <tr
                class="bg-noRiesgo"
                v-tooltip.bottom="{
                  content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Sin riesgo o riesgo despreciable</strong><br><br>Ausencia de riesgo o riesgo tan bajo que no amerita desarrollar actividades de intervención. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de promoción.</span>`,
                  classes: 'contentTooltipRangeInter',
                }"
              >
                Sin riesgo...
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Third Part Quadrants -->
    <div class="box">
      <!-- Principales -->
      <div v-for="(v, k) in groups" :key="k + 'graphsP'">
        <!-- Data Normal -->
        <div class="columns has-text-centered">
          <!-- Column Title -->
          <div class="column is-one-third">
            <div>
              <div
                class="heading is-size-6 border"
                :class="rangoIntervencion(frsm['dataAdmin'][v.first])"
                style="padding-top: 5px; margin-top: 15px;"
              >
                <div class="columns">
                  <!-- Icon -->
                  <div class="column is-2">
                    <i
                      class="material-icons has-text-white icon-dash"
                      v-tooltip.top="'Ver más'"
                      v-on:click="showSubGroups(k)"
                      style="cursor: pointer;"
                    >
                      {{
                        v.active
                          ? "remove_circle_outline"
                          : "add_circle_outline"
                      }}
                    </i>
                  </div>
                  <!-- Text -->
                  <div class="column titleC">
                    {{
                      interpretations[v.first]
                        ? interpretations[v.first].title
                        : "Error en los datos."
                    }}
                  </div>
                  <div
                    v-tooltip.top="{
                      content: createBodyTooltipInter(v),
                      classes: 'contentTooltipInter',
                    }"
                    class="column is-2"
                    v-on:click="
                      getDataInter(frsm['dataAdmin'][v.first], v.title)
                    "
                  >
                    <i
                      class="material-icons has-text-white icon-dash"
                      style="cursor: pointer;"
                    >
                      info
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Ranking -->
          <div class="ranking">
            <div
              class="info"
              style="width: 100%;"
              v-tooltip.bottom="
                'Esta es tu posición actual en base al total de empresas'
              "
            >
              <span class="title-ranking card-position">
                0
              </span>
            </div>
          </div>
          <!-- Columns Graph -->
          <div class="column">
            <div
              style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
            >
              <div
                class="has-text-centered content-nodata-graph"
                :class="rangoIntervencion(frsm['dataAdmin'][v.first])"
                v-if="!validateDataGraph(frsm['dataAdmin'][v.first])"
              >
                <span class="is-flex"
                  ><i class="material-icons">insert_chart</i>&nbsp;No hay
                  suficientes datos</span
                >
              </div>

              <y-graph
                v-if="validateDataGraph(frsm['dataAdmin'][v.first])"
                :datagraph="
                  createDataGraphHorizontalBar(
                    frsm['dataAdmin'][v.first],
                    v.title
                  )
                "
                :cambio="cambio"
                style="height: 65px !important;"
              ></y-graph>
            </div>
          </div>
        </div>

        <article v-if="v.sub && !v.sub2 && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub" :key="kS + 'sub1'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-one-third">
                  <div>
                    <div
                      class="heading is-size-6 border"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      style="padding-top: 5px; margin-top: 15px;"
                    >
                      <div class="columns">
                        <div class="column is-2"></div>
                        <!-- Text -->
                        <div class="column titleC">
                          {{
                            interpretations[vS.first]
                              ? interpretations[vS.first].title
                              : "Error en los datos."
                          }}
                        </div>
                        <div
                          v-tooltip.top="{
                            content: createBodyTooltipInter(vS),
                            classes: 'contentTooltipInter',
                          }"
                          class="column is-2"
                          v-on:click="
                            getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                          "
                        >
                          <i
                            class="material-icons has-text-white icon-dash"
                            style="cursor: pointer;"
                          >
                            info
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Ranking -->
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      'Esta es tu posición actual en base al total de empresas'
                    "
                  >
                    <span class="title-ranking card-position">
                      0
                    </span>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <div
                      class="has-text-centered content-nodata-graph"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      v-if="!validateDataGraph(frsm['dataAdmin'][vS.first])"
                    >
                      <span class="is-flex"
                        ><i class="material-icons">insert_chart</i>&nbsp;No hay
                        suficientes datos</span
                      >
                    </div>

                    <y-graph
                      v-if="validateDataGraph(frsm['dataAdmin'][vS.first])"
                      :datagraph="
                        createDataGraphHorizontalBar(
                          frsm['dataAdmin'][vS.first],
                          vS.title
                        )
                      "
                      :cambio="cambio"
                      style="height: 65px !important;"
                    ></y-graph>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        <article v-if="v.sub2 && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub2" :key="kS + 'sub2'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-one-third">
                  <div>
                    <div
                      class="heading is-size-6 border"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      style="padding-top: 5px; margin-top: 15px;"
                    >
                      <div class="columns">
                        <!-- Icon -->
                        <div class="column is-2">
                          <i
                            data-tooltip="Ver más"
                            class="material-icons has-text-white icon-dash"
                            v-on:click="showSubGroups(k, kS)"
                            style="cursor: pointer;"
                          >
                            {{
                              vS.active
                                ? "remove_circle_outline"
                                : "add_circle_outline"
                            }}
                          </i>
                        </div>
                        <!-- Text -->
                        <div class="column titleC">
                          {{
                            interpretations[vS.first]
                              ? interpretations[vS.first].title
                              : "Error en los datos."
                          }}
                        </div>
                        <div
                          v-tooltip.top="{
                            content: createBodyTooltipInter(vS),
                            classes: 'contentTooltipInter',
                          }"
                          class="column is-2"
                          v-on:click="
                            getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                          "
                        >
                          <i
                            class="material-icons has-text-white icon-dash"
                            style="cursor: pointer;"
                          >
                            info
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Ranking -->
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      'Esta es tu posición actual en base al total de empresas'
                    "
                  >
                    <span class="title-ranking card-position">
                      0
                    </span>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <div
                      class="has-text-centered content-nodata-graph"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      v-if="!validateDataGraph(frsm['dataAdmin'][vS.first])"
                    >
                      <span class="is-flex"
                        ><i class="material-icons">insert_chart</i>&nbsp;No hay
                        suficientes datos</span
                      >
                    </div>
                    <y-graph
                      v-if="validateDataGraph(frsm['dataAdmin'][vS.first])"
                      :datagraph="
                        createDataGraphHorizontalBar(
                          frsm['dataAdmin'][vS.first],
                          vS.title
                        )
                      "
                      :cambio="cambio"
                      style="height: 65px !important;"
                    ></y-graph>
                  </div>
                </div>
              </div>
              <article
                v-if="!v.sub && v.sub2 && vS.sub && vS.active"
                class="message"
              >
                <div class="message-body">
                  <div v-for="(vT, kT) in vS.sub" :key="kT + 'sub3'">
                    <!-- Data Normal -->
                    <div class="columns has-text-centered">
                      <!-- Column Title -->
                      <div class="column is-one-third">
                        <div>
                          <div
                            class="heading is-size-6 border"
                            :class="
                              rangoIntervencion(frsm['dataAdmin'][vT.first])
                            "
                            style="padding-top: 5px; margin-top: 15px;"
                          >
                            <div class="columns">
                              <div class="column is-2"></div>
                              <!-- Text -->
                              <div class="column titleC">
                                {{ interpretations[vT.first].title }}
                              </div>
                              <div
                                v-tooltip.top="{
                                  content: createBodyTooltipInter(vT),
                                  classes: 'contentTooltipInter',
                                }"
                                class="column is-2"
                              >
                                <i
                                  class="material-icons has-text-white icon-dash"
                                  style="cursor: pointer;"
                                  v-on:click="
                                    getDataInter(
                                      frsm['dataAdmin'][vT.first],
                                      vT.title
                                    )
                                  "
                                >
                                  info
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Ranking -->
                      <div class="ranking">
                        <div
                          class="info"
                          style="width: 100%;"
                          v-tooltip.bottom="
                            'Esta es tu posición actual en base al total de empresas'
                          "
                        >
                          <span class="title-ranking card-position">
                            0
                          </span>
                        </div>
                      </div>
                      <!-- Columns Graph -->
                      <div class="column">
                        <div
                          style="padding-top: 0.6% !important; margin: 0px !important;"
                        >
                          <div
                            class="has-text-centered content-nodata-graph"
                            :class="
                              rangoIntervencion(frsm['dataAdmin'][vT.first])
                            "
                            v-if="
                              !validateDataGraph(frsm['dataAdmin'][vT.first])
                            "
                          >
                            <span class="is-flex"
                              ><i class="material-icons">insert_chart</i
                              >&nbsp;No hay suficientes datos</span
                            >
                          </div>
                          <y-graph
                            v-if="
                              validateDataGraph(frsm['dataAdmin'][vT.first])
                            "
                            :datagraph="
                              createDataGraphHorizontalBar(
                                frsm['dataAdmin'][vT.first],
                                vT.title
                              )
                            "
                            :cambio="cambio"
                            style="height: 65px !important;"
                          ></y-graph>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div class="is-flex is-justify-center">
      <!-- Title Efectos -->
      <hr class="has-text-dark" style="width: 30%" />
      <h1
        class="title is-size-4 is-flex"
        style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
      >
        Efectos
        <div
          v-tooltip.top="{
            content: createBodyTooltipInter({ first: 'EFECTOS' }),
            classes: 'contentTooltipInter',
          }"
          style="padding-left: 10px;padding-top: 2px;"
        >
          <i class="material-icons has-text-black-bis">
            info_outline
          </i>
        </div>
      </h1>
      <hr class="has-text-dark" style="width: 30%" />
    </div>

    <div class="box">
      <!-- Efectos -->
      <div v-for="(v, k) in efectos" :key="k + 'graphsE'">
        <div v-if="v.first === 'RGO-09-Engagement'">
          <!-- Part Header of Quadrants - Engagement -->
          <div style="margin-right: 10px; margin-left: 10px;">
            <hr />
          </div>
          <div class="columns has-text-centered">
            <div class="column is-one-third">
              <span class="heading has-text-weight-bold"
                >Prioridad de intervención</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr
                    class="bg-alta"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es mayor o igual a 30%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alta
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es menor a 30%, pero Muy bajo, bajo y medio es mayor o igual a 40%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Media
                  </tr>
                  <tr
                    class="bg-destacado"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Muy alto y alto a 60%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div style="width: 15% !important; margin: auto !important">
              <div class="ranking ranking-only-icon">
                <img
                  src="@/assets/icons/ranking-linear.svg"
                  alt="rankingIconCL7"
                  width="60"
                />
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de efecto</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-2">
                  <tr class="bg-muyAltoEng">
                    Muy alto
                  </tr>
                  <tr class="bg-altoEng">
                    Alto
                  </tr>
                  <tr class="bg-media">
                    Medio
                  </tr>
                  <tr class="bg-bajoEng">
                    Bajo
                  </tr>
                  <tr class="bg-noRiesgoEng">
                    Muy bajo
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Data Normal -->
        <div class="columns has-text-centered">
          <!-- Column Title -->
          <div class="column is-one-third">
            <div>
              <div
                class="heading is-size-6 border"
                :class="
                  rangoIntervencion(
                    frsm['dataAdmin'][v.first],
                    v.first === 'RGO-09-Engagement' ? 1 : 0
                  )
                "
                style="padding-top: 5px; margin-top: 15px;"
              >
                <div class="columns">
                  <!-- Icon -->
                  <div class="column is-2">
                    <i
                      class="material-icons has-text-white icon-dash"
                      v-tooltip.top="'Ver más'"
                      v-on:click="showSubGroups(k)"
                      v-if="v.sub && v.sub.length"
                      style="cursor: pointer;"
                    >
                      {{
                        v.active
                          ? "remove_circle_outline"
                          : "add_circle_outline"
                      }}
                    </i>
                  </div>
                  <!-- Text -->
                  <div class="column titleC">
                    {{ interpretations[v.first].title }}
                  </div>
                  <div
                    v-tooltip.top="{
                      content: createBodyTooltipInter(v),
                      classes: 'contentTooltipInter',
                    }"
                    class="column is-2"
                    v-on:click="
                      getDataInter(frsm['dataAdmin'][v.first], v.title)
                    "
                  >
                    <i
                      class="material-icons has-text-white icon-dash"
                      style="cursor: pointer;"
                    >
                      info
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Ranking -->
          <div class="ranking">
            <div
              class="info"
              style="width: 100%;"
              v-tooltip.bottom="
                'Esta es tu posición actual en base al total de empresas'
              "
            >
              <span class="title-ranking card-position">
                0
              </span>
            </div>
          </div>
          <!-- Columns Graph -->
          <div class="column">
            <div
              style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
            >
              <div
                class="has-text-centered content-nodata-graph"
                :class="
                  rangoIntervencion(
                    frsm['dataAdmin'][v.first],
                    v.first === 'RGO-09-Engagement' ? 1 : 0
                  )
                "
                v-if="!validateDataGraph(frsm['dataAdmin'][v.first])"
              >
                <span class="is-flex"
                  ><i class="material-icons">insert_chart</i>&nbsp;No hay
                  suficientes datos</span
                >
              </div>
              <y-graph
                v-if="validateDataGraph(frsm['dataAdmin'][v.first])"
                :datagraph="
                  createDataGraphHorizontalBar(
                    frsm['dataAdmin'][v.first],
                    v.title
                  )
                "
                :cambio="cambio"
                style="height: 65px !important;"
              ></y-graph>
            </div>
          </div>
        </div>

        <article v-if="v.sub && v.sub.length && v.active" class="message">
          <div class="message-body">
            <div v-for="(vS, kS) in v.sub" :key="kS + 'sub4'">
              <!-- Data Normal -->
              <div class="columns has-text-centered">
                <!-- Column Title -->
                <div class="column is-one-third">
                  <div>
                    <div
                      class="heading is-size-6 border"
                      :class="rangoIntervencion(frsm['dataAdmin'][vS.first])"
                      style="padding-top: 5px; margin-top: 15px;"
                    >
                      <div class="columns">
                        <div class="is-2"></div>
                        <!-- Text -->
                        <div class="column titleC">
                          {{ interpretations[vS.first].title }}
                        </div>
                        <div
                          v-tooltip.top="{
                            content: createBodyTooltipInter(vS),
                            classes: 'contentTooltipInter',
                          }"
                          class="column is-2"
                          v-on:click="
                            getDataInter(frsm['dataAdmin'][vS.first], vS.title)
                          "
                        >
                          <i
                            class="material-icons has-text-white icon-dash"
                            style="cursor: pointer;"
                          >
                            info
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Columns Graph -->
                <div class="column">
                  <div
                    style="padding-top: 0.6% !important; margin: 0px !important;"
                  >
                    <y-graph
                      :datagraph="
                        createDataGraphHorizontalBar(
                          frsm['dataAdmin'][vS.first],
                          vS.title
                        )
                      "
                      :cambio="cambio"
                      style="height: 65px !important;"
                    ></y-graph>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
// import GraphChartJs from "../dashboard/GraphChartJs.vue";
import yGraph from "@/components/dashboard/GraphFrs.vue";
import json from "./interpretaciones.json";

export default {
  data: () => {
    return {
      cambio: 1,
      interpretations: json,
    };
  },
  props: {
    frsm: Object,
    groups: Object,
    efectos: Object,
    rangoIntervencion: Function,
    showSubGroups: Function,
    createBodyTooltipInter: Function,
    getDataInter: Function,
    validateDataGraph: Function,
    calculatePorcentage: Function,
    rangoFp: Function,
  },
  methods: {
    createDataGraphHorizontalBar: function(data, label) {
      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData
            );
            const rango = this.rangoFp(
              x.SubGrupo,
              x.Grupo === "RGO-09-Engagement" ? 1 : 0
            );
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        return dataHorizontalBar;
      }
      return this.horizontalBar;
    },
    createdLineContext(group) {
      if (!group && !Object.keys(this.generalContext.data).length) return null;

      const position = this.summary.total[group].p;
      const context = Object.entries(this.generalContext.data[group]);
      const labels = context.map(([k, v]) => parseInt(k));
      const colors = labels.map((v) => this.getInfoRange(v));

      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: context.map(([k, v]) => {
                return { x: Number(k), y: Number(v) };
              }),
              fill: false,
              color: colors,
              backgroundColor: colors,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
              pointRadius: function(context) {
                const dataIndex = context.dataIndex;
                const dataset = context.dataset.data;

                if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                  return 4;
                }

                const value = dataset[dataIndex].y;
                return value === 0 ? 0 : 4;
              },
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                const value = tooltipItem[0].label;
                return `${this.getInfoRange(value, "title")} (${value})`;
              }.bind(this),
            },
          },
          legend: { display: false, position: "right" },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: 5,
                  min: Math.min(...labels),
                  max: Math.max(...labels),
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: position.toFixed(2),
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: ".",
                  position: "top",
                  fontColor: "#FFFFFF",
                  fontSize: 14,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                  xPadding: 10,
                  yPadding: 0,
                  yAdjust: 0,
                  cornerRadius: 5,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.chart.ctx;

              const xScale = chart.scales["x-axis-0"];
              const yScale = chart.scales["y-axis-0"];

              xScale.ticks.forEach((tick, index) => {
                const tickX = xScale.getPixelForTick(index);
                ctx.fillStyle = this.getInfoRange(tick);
                const tickWidth =
                  index < xScale.ticks.length - 1
                    ? xScale.getPixelForTick(index + 1) - tickX
                    : xScale.right - tickX;

                ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
              });
            },
            afterDatasetsDraw: (chart) => {
              const ctx = chart.ctx;
              const sizeImg = 30;
              // Recorre las anotaciones y dibuja la imagen
              Object.entries(chart.annotation.elements).forEach(
                ([key, annotation]) => {
                  if (annotation.options.type !== "line") return;

                  const model = annotation._model;

                  if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                  if (annotation.options.imagenStatus) {
                    ctx.drawImage(
                      annotation.options.img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg
                    );
                  }

                  // Dibuja una imagen junto al texto de la anotación
                  const img = new Image();
                  img.src = require("@/assets/icons/companyDefault.png");
                  img.onload = () => {
                    annotation.options.img = img;
                    ctx.drawImage(
                      img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg
                    ); // Dibuja la imagen en el gráfico
                    annotation.options.imagenStatus = true;
                  };
                }
              );
            },
          },
        ],
      };
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 16],
          color: "#fda0a0",
          title: "Muy inconveniente",
        },
        {
          range: [16, 30],
          color: "#f5bc95",
          title: "Inconveniente",
        },
        { range: [30, 70], color: "#fde8af", title: "Regular" },
        { range: [70, 84], color: "#d9ead3", title: "Positivo" },
        { range: [84, 100], color: "#76be7c", title: "Excelente" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
  },
  components: {
    yGraph,
    // GraphChartJs,
  },
};
</script>
<style lang="scss" scoped>
.ranking {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 15% !important;
}

.ranking-only-icon {
  width: 100% !important;
  align-items: center;
  flex-direction: column;
  justify-content: center !important;
}

.ranking .info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.ranking .subtitle-ranking {
  line-height: normal;
}

.card-position {
  width: 65px;
  height: 65px;
  color: #4a4a4a;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Benchmark.vue